// Language options for team language selection
export interface LanguageOption {
  code: string
  label: string
}

export const TEAM_LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'ca', label: 'Catalan' },
  { code: 'zh', label: 'Chinese (Mandarin, Simplified)' },
  { code: 'zh-TW', label: 'Chinese (Mandarin, Traditional)' },
  { code: 'cs', label: 'Czech' },
  { code: 'da', label: 'Danish' },
  { code: 'nl', label: 'Dutch' },
  { code: 'en', label: 'English' },
  { code: 'fi', label: 'Finnish' },
  { code: 'fr', label: 'French' },
  { code: 'de', label: 'German' },
  { code: 'el', label: 'Greek' },
  { code: 'hi', label: 'Hindi' },
  { code: 'id', label: 'Indonesian' },
  { code: 'it', label: 'Italian' },
  { code: 'ja', label: 'Japanese' },
  { code: 'ko', label: 'Korean' },
  { code: 'lv', label: 'Latvian' },
  { code: 'ms', label: 'Malay' },
  { code: 'no', label: 'Norwegian' },
  { code: 'pl', label: 'Polish' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'pt-BR', label: 'Brazilian Portuguese' },
  { code: 'ro', label: 'Romanian' },
  { code: 'ru', label: 'Russian' },
  { code: 'sk', label: 'Slovak' },
  { code: 'es', label: 'Spanish' },
  { code: 'sv', label: 'Swedish' },
  { code: 'th', label: 'Thai' },
  { code: 'uk', label: 'Ukrainian' },
  { code: 'vi', label: 'Vietnamese' }
]

export const QUICK_SELECT_TEAM_LANGUAGE_CODES = ['en', 'sv']

export const QUICK_SELECT_TEAM_LANGUAGE_OPTIONS = QUICK_SELECT_TEAM_LANGUAGE_CODES.map((code) =>
  TEAM_LANGUAGE_OPTIONS.find((language) => language.code === code)
).filter((language): language is LanguageOption => Boolean(language))

export const OTHER_TEAM_LANGUAGE_OPTIONS = TEAM_LANGUAGE_OPTIONS.filter(
  (language) => !QUICK_SELECT_TEAM_LANGUAGE_CODES.includes(language.code)
)

/**
 * Get language label from code
 */
export const getLanguageLabel = (code?: string): string => {
  if (!code) {
    return ''
  }

  const language = TEAM_LANGUAGE_OPTIONS.find((lang) => lang.code === code)
  return language?.label || code
}
